import React, { useRef, useEffect } from 'react'
import useIntersectionObserver from '../../common/hooks/useIntersectionObserver'

export default (props) => {
  const { src, className, style, onObserver, observerParams, ...otherProps } = props
  const $img = useRef()
  const entry = useIntersectionObserver($img, observerParams || {})
  useEffect(() => {
    onObserver?.(entry)
    // eslint-disable-next-line no-extra-boolean-cast
    if (!!entry?.isIntersecting) {
      $img.current.src = $img.current.getAttribute('data-src')
    }
  }, [entry])
  return <img className={className} style={style} data-src={src} ref={$img} {...otherProps} />
}
